import { FrameName } from "../config";
import AbstractPoiTileEntity from "./AbstractPoiTileEntity";

class StorageAbandoned2PoiTileEntity extends AbstractPoiTileEntity {
	public static readonly frameName = FrameName.STORAGE_ABANDONED2;
}

export default StorageAbandoned2PoiTileEntity;
